<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import ListingsForm from './ListingsForm';
import ListingsUpdateContact from './ListingsUpdateContact';
import ListingsDataOutput from './inc/ListingsDataOutput';

import ListingsListingInputForm from './Sell/EnterPropertyDetails/ListingsListingInputForm';
import ListingsPhotoUploader from './Sell/PropertyPhotos/ListingsPhotoUploader';

import { FileManager } from 'coryallen-filemanager';
import { CommunicationsTable } from 'coryallen-communications';
import { CartsTable } from 'coryallen-carts';

import pdfSigning from './pdfViewer/pdfSigning';

export default {
  page: {
    title: 'Listings',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, ListingsForm, ListingsUpdateContact, ListingsDataOutput, ListingsListingInputForm, ListingsPhotoUploader, FileManager, CommunicationsTable, CartsTable, pdfSigning },
  data() {
    return {
      title: 'Listings',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Listings', to: '/listings', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,
      page_tab: 8,
      lang: true,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        wheres: {
          id: this.$route.params.id
        },
        withs: {
          user: { total: 0, selects: ['id','name','email','phone','avatar'], norelations: 1, },
          mls: { total: 0, selects: ['id','status','title','office_name','mls_logo','mls_disclaimer','form_fields'], withs: { pdfs: { total: 0, }},},
          carts: { total: 0 },
        },
      },

      files_loading: true,
      files_filters: {
        paginate: 24,
        page: 1,
        total: 0,
        create_dir: true,
        start_dir: '',
        dir: ''
      },

      carts_loading: true,
      carts_filters: {
        wheres: { listing_id: this.$route.params.id, },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Listings\\Models\\Listing',
      },

    }
  },
  computed: {
    estimatedSavings: function() {
      var savings = 0;
      if(this.item.ClosePrice) { savings = (3 / 100) * parseInt(this.item.ClosePrice) }
      else if(this.item.ListPrice) { savings = (3 / 100) * parseInt(this.item.ListPrice) }
      savings = savings.toFixed(0);
      if(savings < 0) { savings = 0; }
      return savings;
    },
    compiledServices: function() {
      var results = [];
      for(var i in this.item.services) {
        var found = false; for(var k in results) { if(results[k].id == this.item.services[i].id) {
          results[k].quantity = parseFloat(results[k].quantity) + parseFloat((this.item.services[i].quantity ? this.item.services[i].quantity : 1));
          found = true;
        } }
        if(!found) {
          if(!this.item.services[i].quantity) { this.item.services[i].quantity = 1; }
          results.push(JSON.parse(JSON.stringify(this.item.services[i])));
        }
      }
      return results;
    },
    compiledOutput: function() {
      var output = {};
      for(var i in this.item) {
        if(typeof this.item[i] != 'array' && typeof this.item[i] != 'object') {
          output[i] = { used: 0, output: (this.item[i] === null ? '' : this.item[i]), };
        }
      }
      if(this.item.additional_input) { for(var i in this.item.additional_input) {
        if(output[i] === undefined) {
          output[i] = { used: 0, output: (this.item.additional_input[i] === null ? '' : this.item.additional_input[i]), };
        }
      } }
      if(this.item.sign_company) { for(var i in this.item.sign_company) {
        if(output[i] === undefined) {
          output[i] = { used: 0, output: (this.item.sign_company[i] === null ? '' : this.item.sign_company[i]), };
        }
      } }
      if(this.item.mls && this.item.mls.form_fields) { for(var page in this.item.mls.form_fields) { for(var content in this.item.mls.form_fields[page].content) {
        if(this.item.mls.form_fields[page].content[content].FieldType == 'reso' || this.item.mls.form_fields[page].content[content].FieldType == 'custom') {
          if(output[this.item.mls.form_fields[page].content[content].StandardName]) {
            output[this.item.mls.form_fields[page].content[content].StandardName].used = output[this.item.mls.form_fields[page].content[content].StandardName].used + 1;
          } else {
            output[this.item.mls.form_fields[page].content[content].StandardName] = {
              used: 1,
              output: (this.item.mls.form_fields[page].content[content].Default === null ? '' : this.item.mls.form_fields[page].content[content].Default),
            };
          }
        }
      } } }
      return output;
    },
  },
  watch: {
    'item.StreetNumber': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.StreetDirPrefix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.StreetName': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.StreetDirSuffix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.StreetSuffix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.UnitNumber': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.City': {handler: function(n, o) {
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.StateOrProvince': {handler: function(n, o) {
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
    'item.PostalCode': {handler: function(n, o) {
      this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
    }},
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/listings/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.Address + " " + this.item.City + " " + this.item.StateOrProvince + " " + this.item.PostalCode;
          this.files_filters.start_dir =  '/listings/'+this.item.id+'/files';
        } else {
          this.$noty.warning("Content could not be found.");
          this.$router.push('/listings');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    delete_listing() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this listing?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/listings/delete/'+this.item.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
              this.$router.push('/listings');
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    set_page(page) {
      // this.calc_values();
      $("html, body").animate({scrollTop:"0px"});
      // history.pushState({}, null, document.location.pathname+"?tab="+page);
      this.page_tab = page;
    },
    downloadimages() {
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true; this.loading = true;
      this.$http.get('/api/listings/downloadimages', {params: {id:this.item.id}, responseType: 'arraybuffer'}).then(res => {
        // console.log(res.headers);
        var newBlob = new Blob([res.data], {type: res.headers['content-type']});
        if(window.navigator && window.navigator.msSaveOrOpenBlob) { window.navigator.msSaveOrOpenBlob(newBlob); return; }
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a'); link.href = data; link.download = this.item.id+'_listing_images.zip'; link.click();
        setTimeout(function () { window.URL.revokeObjectURL(data) }, 100);
        this.disabled = false; this.loading = false;
      }).catch(res => { this.popupErrors(res); this.disabled = false; this.loading = false; });
    },
    removeElement(event) {
      if(event && event.target) { event.target.remove(); }
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" id="listing-checklist" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Form data</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Images</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="files_loading"></span> Files</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="carts_loading"></span> Carts</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>

    <div v-if="item.id">
    
    
      <div class="row mt-4 set-sm-375">
        <div class="col-lg-4">

          <w-listing-box :item="item" class="border _box-shadow-0-1-4-b-2 mb-4"></w-listing-box>

          <div class="mb-4 btn-group-vertical w-100">
            <button type="button" class="btn btn-white text-gray-900 text-left mb-1"><Icon icon="ri:external-link-line" /> View listing on map</button>
            <button type="button" class="btn btn-white text-gray-900 text-left mb-1"><Icon icon="ri:external-link-line" /> Create property flyers</button>
          </div>

          <div class="card-box mb-4">
            <h5 class="section-header mb-3"><Icon icon="ri:account-box-line" /> Contact :</h5>
            <div class="row m-0">
              <div class="_w-60 mr-3">
                <avatar :username="item.user.name" :src="formatImage(item.user.avatar)" :size="60" :rounded="false" class="rounded"></avatar>
              </div>
              <div class="col p-0 text-gray-700 _f-s-13 _lh-17">
                <h5 class="m-0">{{ item.user.name }}</h5>
                <div>{{ item.user.email }}</div>
                <div>{{ formatPhone(item.user.phone) }}</div>
              </div>
            </div>
            <button type="button" class="mt-3 btn btn-block btn-white" @click="$refs.update_contact_modal.show()"><Icon icon="ri:draft-line" /> Change</button>
            <b-modal ref="update_contact_modal" centered size="lg" title="Change contact" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
              <div class="p-0">
                <ListingsUpdateContact :item="item" @hidemodel="(e) => {$refs.update_contact_modal.hide()}"></ListingsUpdateContact>
              </div>
            </b-modal>
          </div>

          <div class="card-box">
            <h5 class="section-header mb-3"><Icon icon="ri:hand-heart-line" /> Package & services :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="text-nowrap border-0"><label>Total Savings :</label></th><td class="border-0 small">{{ formatPrice(estimatedSavings) }}</td></tr>
                  <tr><th class="text-nowrap"><label>Spent on Packages :</label></th><td class="small">{{ formatPrice(item.packages_total) }}</td></tr>
                  <tr><th class="text-nowrap"><label>Total Spent :</label></th><td class="small">{{ formatPrice(item.estimated_total) }}</td></tr>
                </tbody>
              </table>
            </div>


            <h4 v-if="item.active_package">{{ item.active_package.title }}</h4>
            <ul v-if="item.active_package" class="list-unstyled small text-gray-700">
              <li v-for="(serv, serv_i) in item.active_package.services" :key="serv_i" class="border-bottom border-gray-200 p-1">{{ serv.title }}</li>
            </ul>
            <h4 v-if="item.carts && item.carts.length">A La Carte</h4>
            <div v-if="item.carts && item.carts.length" v-for="(cart, cart_i) in item.carts" :key="cart_i">
              <ul class="list-unstyled small text-gray-700 m-0">
                <li v-for="(serv, serv_i) in cart.services" :key="serv_i" class="border-bottom border-gray-200 p-1">(x{{ serv.quantity }}) {{ serv.title }}</li>
              </ul>
            </div>
          </div>

          <div class="card-box">
            <h5 class="section-header mb-3"><Icon icon="ri:building-2-line" /> MLS details :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="text-nowrap border-0"><label>MLS Title :</label></th><td class="border-0 small">{{item.mls.title}}</td></tr>
                  <tr><th class="text-nowrap"><label>Listing ID :</label></th><td class="small">{{item.ListingId}}</td></tr>
                  <tr><th class="text-nowrap"><label>List Date :</label></th><td class="small">{{item.ListingContractDate}}</td></tr>
                  <tr><th class="text-nowrap"><label>List Price :</label></th><td class="small">{{ formatPrice(item.ListPrice, true, false) }}</td></tr>
                  <tr><th class="text-nowrap"><label>Closed Date :</label></th><td class="small">{{item.CloseDate}}</td></tr>
                  <tr><th class="text-nowrap"><label>Closed Price :</label></th><td class="small">{{ formatPrice(item.ClosePrice, true, false) }}</td></tr>
                  <tr><th class="text-nowrap"><label>Last Checked :</label></th><td class="small">{{item.mls.last_idx}}</td></tr>
                  <tr><th class="text-nowrap"><label>Last Change :</label></th><td class="small">{{item.mls_updated_at}}</td></tr>
                  <tr><th class="text-nowrap"><label>Pending Date :</label></th><td class="small">{{item.PendingTimestamp}}</td></tr>
                  <tr><th class="text-nowrap"><label>Expired Date :</label></th><td class="small">{{item.ExpirationDate}}</td></tr>
                  <tr><th class="text-nowrap"><label>Cancelled Date :</label></th><td class="small">{{item.CancellationDate}}</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <button v-if="hasRole(['Dev','Admin'])" type="button" class="btn btn-block btn-outline-danger" @click="delete_listing" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Listing</button>

        </div>
        <div class="col-lg-8">
          
          <div v-show="tabIndex == 0">
            <div v-if="item.StandardStatus == 'Awaiting Forms'" class="alert alert-warning _c-pointer" @click="removeElement($event)"><Icon icon="ri:close-fill" height="24" class="mt-0 float-right" /> Be cautious when editing listings still in Awaiting Forms stage. Any changes you make could overwrite changes the client has made and visa versa. It is best to make changes to listings after the client has submitted the listing past the Awaiting Forms stage.</div>

            <ListingsForm :item="item"></ListingsForm>
          </div>

          <div v-show="tabIndex == 1">
            <div v-if="item.StandardStatus == 'Awaiting Forms'" class="alert alert-warning _c-pointer" @click="removeElement($event)"><Icon icon="ri:close-fill" height="24" class="mt-0 float-right" /> Be cautious when editing listings still in Awaiting Forms stage. Any changes you make could overwrite changes the client has made and visa versa. It is best to make changes to listings after the client has submitted the listing past the Awaiting Forms stage.</div>
            
            <div class="row">
              <div class="col-sm-6">
                <div class="card-box">
                  <h5 class="mb-3 text-uppercase bg-light p-2"><Icon icon="ri:file-pdf-2-line" /> PDF view/download</h5>
                  <b-modal ref="viewpdf" centered size="xl" title="PDF view/download" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
                    <div class="p-3">
                      <pdfSigning :item="item" :compiledOutput="compiledOutput"></pdfSigning>
                    </div>
                    <footer class="modal-footer modal-footer-custom">
                      <button type="button" class="btn btn-light" @click="$refs.viewpdf.hide()">Close</button>
                    </footer>
                  </b-modal>
                  <button type="button" class="btn btn-block btn-primary" @click="$refs.viewpdf.show()"><Icon icon="ri:external-link-line" /> PDF view/download</button>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="card-box">
                  <h5 class="mb-3 text-uppercase bg-light p-2"><Icon icon="ri:database-2-line" /> View data output</h5>
                  <b-modal ref="viewoutput" centered size="xl" title="Listing data outoput" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
                    <ListingsDataOutput :item="item"></ListingsDataOutput>
                    <footer class="modal-footer modal-footer-custom">
                      <button type="button" class="btn btn-light" @click="$refs.viewoutput.hide()">Close</button>
                    </footer>
                  </b-modal>
                  <button type="button" class="btn btn-block btn-primary" @click="$refs.viewoutput.show()"><Icon icon="ri:external-link-line" /> View data output</button>
                </div>
              </div>
            </div>

            <div class="card-box">
              <transition name="fade" mode="out-in">
                <ListingsListingInputForm
                  v-for="(page, page_i) in item.mls.form_fields"
                  v-if="page_tab == 7 + (page_i + 1)"
                  :key="7 + (page_i + 1)"
                  :item="item"
                  :mls_page="page_i"
                  :lang="lang"
                  :admin="true"
                  @setpage="set_page"
                ></ListingsListingInputForm>
              </transition>
            </div>
          </div>

          <div v-show="tabIndex == 2">
            <div class="card-box position-relative">
              <form @submit.prevent="downloadimages()" method="post">
                <button type="submit" class="btn btn-primary"><Icon icon="ri:download-2-line" /> Download All</button>
              </form>
              <ListingsPhotoUploader :item="item" :admin="true"></ListingsPhotoUploader>
            </div>
          </div>

          <div v-show="tabIndex == 3">
            <FileManager v-if="item.id && files_filters.start_dir" :filters="files_filters" @loadchange="(e) => {files_loading = e}"></FileManager>
          </div>

          <div v-show="tabIndex == 4">
            <div class="card-box p-0 position-relative">
              <CartsTable ref="CartsTable" :listing="item" :changefilters="carts_filters" @loadchange="(e) => {carts_loading = e}" @fetchdata="fetchData()"></CartsTable>
            </div>
          </div>

          <div v-show="tabIndex == 5">
            <div class="">
              <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'Address'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
            </div>
          </div>

        </div>
      </div>
    </div>

  </Layout>
</template>
